/*
 * @Author: Ashley.Liu
 * @Date: 2022-06-28 14:17:15
 * @LastEditTime: 2023-02-06 16:17:28
 * @Description: desc
 */
import Layout from '../views/Layout'

export default [
  {
    path: '/esms',
    component: Layout,
    name: 'ESMS Management',
    redirect: '/esms/es',
    meta: { title: 'esms' },
    children: [
      {
        path: 'es',
        name: 'es',
        component: () => import('../views/esms/es')
      },
      {
        path: 'es_node',
        name: 'es_node',
        component: () => import('../views/esms/es_node')
      },
      {
        path: 'es_user',
        name: 'es_user',
        component: () => import('../views/esms/es_user')
      },
      {
        path: 'es_metrics',
        name: 'es_metrics',
        component: () => import('../views/esms/es_metrics')
      },
      {
        path: 'rest',
        name: 'rest',
        component: () => import('../views/esms/rest')
      },
      {
        path: 'policy',
        name: 'policy',
        component: () => import('../views/esms/es_policy')
      },
      {
        path: 'indexLifecycle',
        name: 'indexLifecycle',
        component: () => import('../views/esms/es_indexLifecycle')
      },
      {
        path: 'unneedManage',
        name: 'unneedManage',
        component: () => import('../views/esms/es_unneedManage')
      },
      {
        path: 'index',
        name: 'Index'
      }
    ]
  },
  {
    path: '/esinfo',
    component: Layout,
    meta: { title: 'Cluster' },
    redirect: '/esinfo/cluster',
    name: 'ES Management',
    children: [
      {
        path: 'cluster',
        name: 'Cluster',
        component: () =>
          import(/* webpackChunkName: "cluster" */ '../views/esinfo/cluster'),
        meta: { title: 'Cluster' },
        children: [
          {
            path: 'detail',
            name: 'detail',
            component: () =>
              import(
                /* webpackChunkName: "clusterDetail" */ '../views/esinfo/cluster/clusterDetail'
              ),
            meta: { title: 'Detail of Cluster' }
          },
          {
            path: 'snapshot',
            name: 'Snapshot',
            component: () => import('../views/esinfo/snapshot'),
            meta: { title: 'Snapshot Repository Manage' },
            children: [
              {
                path: 'history',
                name: 'History',
                component: () =>
                  import('../views/esinfo/snapshot/restoreHistory.vue'),
                meta: { title: 'Restore History' },
                props: route => ({
                  esId: route.query.esId,
                  repoName: route.query.repoName,
                  name: route.query.name
                })
              }
            ]
          }
        ]
      },
      {
        path: 'index-manage',
        name: 'IndexManage',
        component: () => import('../views/esinfo/indexManage'),
        meta: { title: 'Index Manage' },
        children: [
          {
            path: 'report',
            name: 'Report',
            component: () =>
              import(
                /* webpackChunkName: "IndexManage" */ '../views/esinfo/indexManage/indexOverview.vue'
              ),
            meta: { title: 'Detail of Index' },
            props: route => ({
              esId: route.query.esId,
              indexId: route.query.indexId,
              indexName: route.query.indexName
            })
          }
        ]
      },
      {
        path: 'channel',
        name: 'ChannelManage',
        component: () =>
          import(
            /* webpackChunkName: "ChannelManage" */ '../views/esinfo/channel'
          ),
        meta: { title: 'IM Channel' }
      },
      {
        path: 'alarm',
        name: 'AlarmConfig',
        component: () => import('../views/esinfo/alarmConfig/index.vue'),
        meta: { title: 'Alarm' },
        children: [
          {
            path: 'create',
            name: 'AlarmDetail',
            component: () =>
              import(
                /* webpackChunkName: "createAlarm" */ '../views/esinfo/alarmConfig/detail.vue'
              ),
            meta: { title: 'Detail of Alarm' },
            children: [
              {
                path: 'notify',
                name: 'NotifyDetail',
                component: () =>
                  import(
                    /* webpackChunkName: "createAlarm" */ '../views/esinfo/alarmConfig/notifyForm.vue'
                  ),
                meta: { title: 'Notify' }
              }
            ]
          }
        ]
      },
      {
        path: 'alarm-records',
        name: 'AlarmRecords',
        component: () =>
          import(
            /* webpackChunkName: "AlarmRecords" */ '../views/esinfo/alarmRecords'
          ),
        meta: { title: 'Alarm Records' },
        children: [
          {
            path: 'detail',
            name: 'RecordsDetail',
            component: () =>
              import(
                /* webpackChunkName: "AlarmRecordsDetail" */ '../views/esinfo/alarmRecords/detail.vue'
              )
          }
        ]
      },
      {
        path: 'role',
        name: 'Role',
        component: () =>
          import(
            /* webpackChunkName: "esms-role-manage" */ '../views/esinfo/setting/role'
          ),
        meta: { title: 'Role' }
      },
      {
        path: 'dictionary',
        name: 'dictionary',
        component: () =>
          import(
            /* webpackChunkName: "esms-dictionary" */ '../views/esinfo/setting/dictionary'
          )
      },
      {
        path: 'tools/analyzer',
        name: 'analyzer',
        component: () =>
          import(
            /* webpackChunkName: "esms-analyzer" */ '../views/esinfo/tools/analyzer'
          )
      },
      {
        path: 'transfer',
        name: 'Transfer',
        component: () =>
          import(/* webpackChunkName: "esms-transfer" */ '../views/transfer'),
        meta: { title: 'Transfer' }
      },
      {
        path: 'sync',
        name: 'Sync',
        component: () =>
          import(
            /* webpackChunkName: "esms-template-sync" */ '../views/esinfo/sync'
          ),
        meta: { title: 'Template Sync' }
      },
      {
        path: 'jobManage',
        name: 'Job Manage',
        component: () =>
          import(
            /* webpackChunkName: "esms-job-manage" */ '../views/esinfo/jobManage.vue'
          ),
        meta: { title: 'Job Manage' }
      },
      {
        path: 'incident',
        name: 'Incident',
        component: () => import('../views/IncidentNotification.vue'),
        meta: { title: 'Incident' }
      },
      {
        path: 'helpDocsManage',
        name: 'HelpDocsManage',
        component: () => import('../views/esinfo/tools/helpDocsManage.vue'),
        meta: { title: 'HelpDocsManage' }
      }
    ]
  }
]
